export default __webpack_public_path__ + "static/media/ci-convert-new.f948684a.svg";